import { mountAccount } from "../account";
import { mountAnalytics } from "../analytics";
import { mountBanner } from "../site-banner";
import { mountTheme } from "../theme";
mountTheme();
mountAccount();
// Only the close button. Whether the banner is there at all was settled
// before the paint, by the inline script above.
mountBanner();
// Here rather than in main.ts because main.ts is the app's entry point
// and never runs on the blog, which is where most first visits land.
void mountAnalytics();